import React from 'react'

function Support() {
    return (
        <div>
            {document.location = 'https://m.me/DoanHoiITUTE'}
        </div>
    )
}

export default Support
